(function () {
  'use strict';

  angular
    .module('MktzapApp.Controllers')
    .controller('HistorySettingsController', HistorySettingsController);

  HistorySettingsController.$inject = ['$rootScope', 'CompanyService', 'NotificationService', 'SectorService'];

  function HistorySettingsController ($rootScope, CompanyService, NotificationService, SectorService) {
    $rootScope.getPageLabels('menu.config.historySettings')

    var vmHistorySettingsCtrl = this
    vmHistorySettingsCtrl.sectors = []

    CompanyService
      .loadMetadata()
      .$promise
      .then(function (data) {
        vmHistorySettingsCtrl.metadata = data
      })
      .catch(function (error) {
        NotificationService.errorHandler(error, $rootScope.labels.errorLoadMeta)
      })

    SectorService
      .loadSectorsByCompany()
      .$promise
      .then(data => {
        vmHistorySettingsCtrl.sectors = data.sectors
      })
      .catch(error => {
        NotificationService.errorHandler(error, $rootScope.labels.errorLoadMeta)
      })

    vmHistorySettingsCtrl.ActivePhoneMask = () => {
      let enabledPhoneMask = vmHistorySettingsCtrl.metadata['phone_mask'] && vmHistorySettingsCtrl.metadata['phone_mask'].branch

      if (!enabledPhoneMask) {
        vmHistorySettingsCtrl.metadata['phone_mask'] = {
          "branch": false,
          "user_manager": false,
          "user_supervisor": false,
          "user_operator": false,
          "user_promoter": false,
          "user_administrator": false
        }

        return
      }

      vmHistorySettingsCtrl.metadata['phone_mask'] = {
        "branch": vmHistorySettingsCtrl.metadata['phone_mask'].branch ? true : false,
        "user_manager": vmHistorySettingsCtrl.metadata['phone_mask'].user_manager ? true : false,
        "user_supervisor": vmHistorySettingsCtrl.metadata['phone_mask'].user_supervisor ? true : false,
        "user_operator": vmHistorySettingsCtrl.metadata['phone_mask'].user_operator ? true : false,
        "user_promoter": vmHistorySettingsCtrl.metadata['phone_mask'].user_promoter ? true : false,
        "user_administrator": vmHistorySettingsCtrl.metadata['phone_mask'].user_administrator ? true : false
      }
    }

    vmHistorySettingsCtrl.ActiveDocMask = () => {
      let enabledDocMask = vmHistorySettingsCtrl.metadata['doc_mask'] && vmHistorySettingsCtrl.metadata['doc_mask'].branch

      if (!enabledDocMask) {
        vmHistorySettingsCtrl.metadata['doc_mask'] = {
          "branch": false,
          "user_manager": false,
          "user_supervisor": false,
          "user_operator": false,
          "user_promoter": false,
          "user_administrator": false,
          "sectors": false
        }

        return
      }

      vmHistorySettingsCtrl.metadata['doc_mask'] = {
        "branch": vmHistorySettingsCtrl.metadata['doc_mask'].branch ? true : false,
        "user_manager": vmHistorySettingsCtrl.metadata['doc_mask'].user_manager ? true : false,
        "user_supervisor": vmHistorySettingsCtrl.metadata['doc_mask'].user_supervisor ? true : false,
        "user_operator": vmHistorySettingsCtrl.metadata['doc_mask'].user_operator ? true : false,
        "user_promoter": vmHistorySettingsCtrl.metadata['doc_mask'].user_promoter ? true : false,
        "user_administrator": vmHistorySettingsCtrl.metadata['doc_mask'].user_administrator ? true : false,
        "sectors": vmHistorySettingsCtrl.metadata['doc_mask'].sectors ? vmHistorySettingsCtrl.metadata['doc_mask'].sectors : []
      }
    }

    vmHistorySettingsCtrl.ActiveHistoryMenu = () => {
      let enabledHistoryMenu = vmHistorySettingsCtrl.metadata['history_menu'] && vmHistorySettingsCtrl.metadata['history_menu'].branch

      if (!enabledHistoryMenu) {
        vmHistorySettingsCtrl.metadata['history_menu'] = {
          "branch": false,
          "user_manager": false,
          "user_supervisor": false,
          "user_operator": false,
          "user_promoter": false,
          "user_administrator": false
        }

        return
      }

      vmHistorySettingsCtrl.metadata['history_menu'] = {
        "branch": vmHistorySettingsCtrl.metadata['history_menu'].branch ? true : false,
        "user_manager": vmHistorySettingsCtrl.metadata['history_menu'].user_manager ? true : false,
        "user_supervisor": vmHistorySettingsCtrl.metadata['history_menu'].user_supervisor ? true : false,
        "user_operator": vmHistorySettingsCtrl.metadata['history_menu'].user_operator ? true : false,
        "user_promoter": vmHistorySettingsCtrl.metadata['history_menu'].user_promoter ? true : false,
        "user_administrator": vmHistorySettingsCtrl.metadata['history_menu'].user_administrator ? true : false
      }
    }

    vmHistorySettingsCtrl.allow = () => {
      vmHistorySettingsCtrl.ActivePhoneMask()
      vmHistorySettingsCtrl.ActiveDocMask()
      vmHistorySettingsCtrl.ActiveHistoryMenu()

      CompanyService
        .saveMetadata(vmHistorySettingsCtrl.metadata)
        .$promise
        .then(function (data) {
          $rootScope.company_metadata = data;
          NotificationService.successHandler(data, $rootScope.labels.saveConfig)
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.errorConfig)
        })
    }

    vmHistorySettingsCtrl.changeSectors = (id) => {
      if (!vmHistorySettingsCtrl.metadata['doc_mask'].sectors) {
        vmHistorySettingsCtrl.metadata['doc_mask'].sectors = []
        return
      }

      if (vmHistorySettingsCtrl.metadata['doc_mask'].sectors.indexOf(id) > -1) {
        vmHistorySettingsCtrl.metadata['doc_mask'].sectors.splice(vmHistorySettingsCtrl.metadata['doc_mask'].sectors.indexOf(id), 1)
        return
      }

      vmHistorySettingsCtrl.metadata['doc_mask'].sectors.push(id)
    }

    
  }
})();
